import React from 'react'
import {NavLink} from "react-router-dom";

class Footer extends React.Component {

    constructor(props) {
        super(props);
    }

    redirectionFunction = (type, url) => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: type,
            }));
            window.location.href = "/#";
        }else {
            window.open(url, '_blank' );
        }
    }

    render() {
        const { pageType } = this.props;

        return <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className={pageType ? "col-md-6" : "col-md-12"}>
                        <div className="ftsocial">
                            <a href="https://www.linkedin.com/company/wenaturalists" target="_blank"><i class="iSocial_LinkedIn"></i></a>
                            <a href=" https://www.instagram.com/WeNaturalists/" target="_blank"><i class="iSocial_Instagram"></i></a>
                            <a href=" https://twitter.com/WeNaturalists" target="_blank"><i class="iSocial_Twitter"></i></a>
                            <a href="https://www.facebook.com/WeNaturalists/" target="_blank"><i class="iSocial_FB"></i></a>			
                            <a href="https://www.youtube.com/channel/UCUFUqiJGKl9nj_v6fcbsTnw?view_as=subscriber" target="_blank"><i class="iYouTube_Logo"></i></a>	
                            <a href="https://medium.com/wenaturalists" target="_blank"><i class="iSocial_Medium"></i></a>			
                            <a href=" https://in.pinterest.com/WeNaturalists/" target="_blank"><i class="iSocial_Pinterest"></i></a>
                        </div>
                    </div>

                    {pageType &&
                        <div className="col-md-6 mb-2 mb-md-0">
                            <ul className='callmailInfo text-center text-md-right'>
                                <li>
                                    <a href='tel:+91 99206 05555'><i class="fa fa-phone" aria-hidden="true" /> +91 99206 05555</a>
                                </li>
                                <li>
                                    <a href='mailto:support@wenaturalists.com'><i class="fa fa-envelope" aria-hidden="true" /> support@wenaturalists.com</a>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
                <div className="row">
                    <div className="col-lg-7 ftlinks">
                        <ul>
                            <li><a href="javascript:void(0)" onClick={(e) => this.redirectionFunction("privacyPolicy", '/PrivacyPolicy')}>Privacy Policy</a></li>
                            <li><a href="javascript:void(0)" onClick={(e) => this.redirectionFunction("termsConditions", '/TermsConditions')}>Terms & Conditions</a></li>
                            {/*<li><NavLink exact to="/UserAgreement">User Agreement</NavLink></li>*/}
                            <li><a href="javascript:void(0)" onClick={(e) => this.redirectionFunction("cookiePolicy", '/CookiePolicy')}>Cookie Policy</a></li>
                        </ul>
                    </div>
                    <div className="col-lg-5 copyright">All Rights Reserved. 2019 © Dscovr Journeys</div>
                </div>
            </div>
        </footer>

    }
}

export default Footer
